var _rect, _path, _path2, _rect2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEInvoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.00049,
    y: 3.5,
    width: 2.5,
    height: 1,
    fill: "#37833B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0005 5V4L6.99899 1H1.50149C1.22499 1 1.00049 1.2275 1.00049 1.496V10.504C1.00062 10.6356 1.05299 10.7618 1.14609 10.8548C1.23918 10.9478 1.36539 11 1.49699 11H6.00049V10H2.00049V2H6.50049V4.5H9.00049V5H10.0005Z",
    fill: "#37833B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50049 9.5H9.25049C9.31679 9.5 9.38038 9.47366 9.42727 9.42678C9.47415 9.37989 9.50049 9.3163 9.50049 9.25C9.50049 9.1837 9.47415 9.12011 9.42727 9.07322C9.38038 9.02634 9.31679 9 9.25049 9H7.25049C6.91897 9 6.60103 8.8683 6.3666 8.63388C6.13218 8.39946 6.00049 8.08152 6.00049 7.75C6.00049 7.41848 6.13218 7.10054 6.3666 6.86612C6.60103 6.6317 6.91897 6.5 7.25049 6.5H7.75049V5.5H8.75049V6.5H10.0005V7.5H7.25049C7.18418 7.5 7.1206 7.52634 7.07371 7.57322C7.02683 7.62011 7.00049 7.6837 7.00049 7.75C7.00049 7.8163 7.02683 7.87989 7.07371 7.92678C7.1206 7.97366 7.18418 8 7.25049 8H9.25049C9.58201 8 9.89995 8.1317 10.1344 8.36612C10.3688 8.60054 10.5005 8.91848 10.5005 9.25C10.5005 9.58152 10.3688 9.89946 10.1344 10.1339C9.89995 10.3683 9.58201 10.5 9.25049 10.5H8.75049V11.5H7.75049V10.5H6.50049V9.5Z",
    fill: "#37833B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.00049,
    y: 5.5,
    width: 2.5,
    height: 1,
    fill: "#37833B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEInvoice);
export default __webpack_public_path__ + "static/media/e_invoice.5c371d6652fd5005e5109aea64c92583.svg";
export { ForwardRef as ReactComponent };